class LoadMoreProducts {
  constructor() {
    this.loadMoreBtn = document.querySelector('.load-more-btn');
    this.productGrid = document.querySelector('#ProductGrid, .collection .grid, [data-id="product-grid"]');
    this.facetFilters = document.querySelector('facet-filters-form, .facets-container');
    this.loading = false;
    this.init();
  }

  init() {
    if (this.loadMoreBtn) {
      this.loadMoreBtn.addEventListener('click', this.loadMore.bind(this));
    }

    // Escuchar cambios en filtros para resetear el botón
    if (this.facetFilters) {
      this.facetFilters.addEventListener('facet:changed', this.handleFilterChange.bind(this));
      // También escuchar el evento nativo de Dawn
      document.addEventListener('facet:updated', this.handleFilterChange.bind(this));
    }
  }

  handleFilterChange() {
    // Cuando cambian los filtros, resetear el botón de cargar más
    setTimeout(() => {
      this.resetLoadMoreButton();
    }, 500);
  }

  resetLoadMoreButton() {
    const newLoadMoreBtn = document.querySelector('.load-more-btn');
    if (newLoadMoreBtn) {
      this.loadMoreBtn = newLoadMoreBtn;
      this.loadMoreBtn.addEventListener('click', this.loadMore.bind(this));
    }
  }

  loadMore() {
    if (this.loading) return;

    const nextUrl = this.loadMoreBtn.dataset.nextUrl;
    const currentPage = parseInt(this.loadMoreBtn.dataset.currentPage);
    const totalPages = parseInt(this.loadMoreBtn.dataset.totalPages);

    this.setLoading(true);

    // Construir URL manteniendo todos los filtros actuales
    const url = this.buildUrlWithFilters(nextUrl);

    fetch(url.toString())
      .then((response) => response.text())
      .then((html) => this.handleResponse(html, currentPage, totalPages))
      .catch((error) => this.handleError(error));
  }

  buildUrlWithFilters(nextUrl) {
    const url = new URL(nextUrl, window.location.origin);
    const currentParams = new URLSearchParams(window.location.search);

    // Mantener todos los parámetros de filtros
    currentParams.forEach((value, key) => {
      if (key !== 'page') {
        url.searchParams.set(key, value);
      }
    });

    // También capturar filtros desde formularios activos
    const activeFilters = document.querySelectorAll(
      'input[name*="filter"]:checked, select[name*="filter"] option:checked'
    );
    activeFilters.forEach((filter) => {
      if (filter.name && filter.value) {
        url.searchParams.set(filter.name, filter.value);
      }
    });

    return url;
  }

  handleResponse(html, currentPage, totalPages) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    // Buscar productos en múltiples posibles contenedores
    const possibleSelectors = [
      '#ProductGrid .grid__item',
      '.collection .grid .grid__item',
      '[data-id="product-grid"] .grid__item',
      '.product-grid .grid__item',
    ];

    let newProducts = [];
    for (const selector of possibleSelectors) {
      newProducts = doc.querySelectorAll(selector);
      if (newProducts.length > 0) break;
    }

    if (newProducts.length === 0) {
      this.handleError(new Error('No se encontraron productos'));
      return;
    }

    // Añadir productos con animación escalonada
    this.addProductsWithAnimation(newProducts);

    // Actualizar estado del botón
    this.updateButton(currentPage, totalPages);

    // Actualizar contador de productos si existe
    this.updateProductCount();
  }

  addProductsWithAnimation(newProducts) {
    newProducts.forEach((product, index) => {
      // Clonar el producto para evitar referencias duplicadas
      const productClone = product.cloneNode(true);

      setTimeout(() => {
        productClone.style.opacity = '0';
        productClone.style.transform = 'translateY(20px)';
        this.productGrid.appendChild(productClone);

        // Animar entrada
        requestAnimationFrame(() => {
          productClone.style.transition = 'opacity 0.4s ease, transform 0.4s ease';
          productClone.style.opacity = '1';
          productClone.style.transform = 'translateY(0)';
        });

        // Triggear eventos para componentes de Dawn (quick-add, etc.)
        this.initializeNewProductComponents(productClone);
      }, index * 100);
    });
  }

  initializeNewProductComponents(productElement) {
    // Reinicializar componentes de Dawn en los nuevos productos
    const quickAddBtns = productElement.querySelectorAll('quick-add-modal button');
    quickAddBtns.forEach((btn) => {
      // Forzar reinicialización del componente quick-add
      if (window.customElements && window.customElements.get('quick-add-modal')) {
        btn.dispatchEvent(new Event('DOMContentLoaded'));
      }
    });

    // Reinicializar swatches de colores si existen
    const colorSwatches = productElement.querySelectorAll('.color-swatch');
    colorSwatches.forEach((swatch) => {
      swatch.addEventListener('click', function () {
        // Lógica de swatches si es necesaria
      });
    });
  }

  updateButton(currentPage, totalPages) {
    const nextPage = currentPage + 1;

    if (nextPage <= totalPages) {
      // Construir nueva URL para siguiente página
      const currentUrl = new URL(window.location);
      currentUrl.searchParams.set('page', nextPage + 1);

      this.loadMoreBtn.dataset.nextUrl = currentUrl.toString();
      this.loadMoreBtn.dataset.currentPage = nextPage;
      this.setLoading(false);
    } else {
      this.hideButton();
    }
  }

  updateProductCount() {
    // Actualizar contador de productos mostrados
    const productCount = document.querySelector('.collection-product-count');
    if (productCount) {
      const currentCount = this.productGrid.querySelectorAll('.grid__item').length;
      productCount.textContent = `Mostrando ${currentCount} productos`;
    }
  }

  setLoading(loading) {
    this.loading = loading;

    if (loading) {
      this.loadMoreBtn.innerHTML = `
        <span class="loading-spinner"></span>
        Cargando productos...
      `;
      this.loadMoreBtn.disabled = true;
      this.loadMoreBtn.classList.add('loading');
    } else {
      this.loadMoreBtn.innerHTML = 'Cargar más productos';
      this.loadMoreBtn.disabled = false;
      this.loadMoreBtn.classList.remove('loading');
    }
  }

  hideButton() {
    this.loadMoreBtn.style.display = 'none';

    // Mostrar mensaje de fin
    const endMessage = document.createElement('div');
    endMessage.className = 'load-more-end';
    endMessage.innerHTML = `
      <p>✓ Has visto todos los productos disponibles</p>
      <small>Usa los filtros para refinar tu búsqueda</small>
    `;
    this.loadMoreBtn.parentNode.appendChild(endMessage);
  }

  handleError(error) {
    console.error('Error loading more products:', error);
    this.loadMoreBtn.innerHTML = '⚠️ Error - Intentar de nuevo';
    this.loadMoreBtn.disabled = false;
    this.loadMoreBtn.classList.add('error');
    this.loading = false;

    // Auto-reset después de 3 segundos
    setTimeout(() => {
      this.setLoading(false);
      this.loadMoreBtn.classList.remove('error');
    }, 3000);
  }
}

// Inicializar cuando el DOM esté listo
document.addEventListener('DOMContentLoaded', () => {
  new LoadMoreProducts();
});

// Reinicializar después de actualizaciones de filtros
document.addEventListener('facet:updated', () => {
  setTimeout(() => {
    new LoadMoreProducts();
  }, 100);
});
